import {
	FETCH_TOPICS_REQUEST,
	FETCH_TOPICS_SUCCESS,
	FETCH_TOPICS_FAIL,
	UPDATE_TOPIC_REQUEST,
	UPDATE_TOPIC_SUCCESS,
	UPDATE_TOPIC_FAIL,
} from "../constants/topic";

function fetchTopicsReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", topics: {}, error: null };
	}
	switch (action.type) {
		case FETCH_TOPICS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_TOPICS_SUCCESS:
			return { loading: false, status: "SUCCEEDED", topics: action.payload };
		case FETCH_TOPICS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateTopicReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case UPDATE_TOPIC_REQUEST:
			return { loading: true };
		case UPDATE_TOPIC_SUCCESS:
			return { loading: false, status: "SUCCEEDED" };
		case UPDATE_TOPIC_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

export { fetchTopicsReducer, updateTopicReducer };
